// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Project } from '@/project/api/types';
import { sumBy } from 'lodash-es';

/**
 * Returns the number of assets requested for a project.
 *
 * @param project - The project for which to get the requested asset count.
 */
export function getRequestedAssetCount(project: Pick<Project, 'assignments'>) {
  return sumBy(project.assignments, 'requestedCount');
}
